import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import globalComponents from '@/components';
import globalContants from '@/constants/globalContants';
import AppElectron from '@/AppElectron.vue';
import { isElectronSinglePage, electronMixin } from '@/utils/electronHelper';
import Vue3Dragscroll from 'vue3-dragscroll';
import router from './router';
import store from './store';
// import i18n from './locale';
import useVxeTable from './init/vxeTable';
import installVxeTableCustomColWidth from './init/vxeTable/installVxeTableCustomColWidth';
import useSentry from './init/sentry';
import directive from './directive';
import App from './App.vue';
import '@/utils/base64';
import '@/utils/image-interceptor';
// Styles are imported via arco-plugin. See config/plugin/arcoStyleImport.ts in the directory for details
// 样式通过 arco-plugin 插件导入。详见目录文件 config/plugin/arcoStyleImport.ts
// https://arco.design/docs/designlab/use-theme-package
// import '@/assets/style/global.less';
// import '@/assets/style/index';
// import '@/api/interceptor';

// 覆盖amis样式
import '@/assets/style/index';

const app = createApp(isElectronSinglePage() ? AppElectron : App);
app.config.globalProperties.$globalContants = globalContants;
app.provide('globalContants', globalContants);
app.use(ArcoVue, {});
app.use(ArcoVueIcon);

electronMixin(app);

if (!isElectronSinglePage()) {
  useSentry(app, router);
}
useVxeTable(app);
installVxeTableCustomColWidth(app, {
  minWidth: 40,
  strictClipSelectors: ['.arco-tag'],
});
app.use(router);
app.use(store);
// app.use(i18n);
app.use(globalComponents);
app.use(directive);
// 拖拽滚动组件
app.use(Vue3Dragscroll);

app.mount('#app');
